import { __rest } from 'tslib';
import React from 'react';
import { useTheme } from '@10d/tend-ui-theme';
import cn from 'classnames';
import { Root } from './styled.js';

const Strong = React.forwardRef((_a, ref) => {
    var { className } = _a, props = __rest(_a, ["className"]);
    const theme = useTheme();
    return (React.createElement(Root, Object.assign({ "data-testid": 'tend-ui-strong' }, props, { ref: ref, theme: theme, className: cn(['tend-ui-typography-string', className]) })));
});
Strong.displayName = 'Strong';

export { Strong };
//# sourceMappingURL=Strong.js.map
